'use strict';

angular.module('amexReconciliationApp')
  .service('CardRepository', function ($resource) {
    var self = this;

    var cardresource = $resource(
      '/api/v1/cards/findByBca', {},
      {
        'get': {method: 'GET', isArray: true}
      }
    );

    self.findByBca = function(rcaNumber, bcaNumber, endDates) {
      return cardresource
        .get({ rcaNumber: rcaNumber, bcaNumber: bcaNumber, endDates: endDates }).$promise;
    };

    var cardResourceForAccountingLine = $resource(
      '/api/v1/cards/findByAccountingLine', {},
      {
        'get': {method: 'GET', isArray: true}
      }
    );

    self.findByAccountingLine = function(siteNumber, linkKey, concatValue, endDates) {
      return cardResourceForAccountingLine
        .get({
          siteNumber: siteNumber,
          linkKey: linkKey,
          concatValue: concatValue,
          endDates: endDates
        }).$promise;
    };
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/CardRepository.js
// module id = 606
// module chunks = 0